import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
 /* @font-face {
    font-family: Nexa;
    font-style: normal;
    src: url("../../fonts/Nexa/Fontfabric\ -\ Nexa\ Regular.otf");
}

@font-face {
    font-family: Nexa-light;
    font-style: normal;
    src: url("../../fonts/Nexa/Fontfabric\ -\ Nexa\ Light.otf");
}

@font-face {
    font-family: Nexa-bold;
    font-style: normal;
    src: url("../../fonts/Nexa/Fontfabric\ -\ Nexa\ Bold.otf");
}*/
`;

export default GlobalStyle;
